const validator = {
    init() {

        const text = $('input[type=text]');
        const select = $('input[type=select]');

        text.on('keyup', function(){
            if(this.value == '' ){
                $(this).parent().addClass('validation');
                $(this).parent().removeClass('validated');
                $(this).parent().find('.validation-field').remove();
                $(this).parent().append('<p class="validation-field">This field is required</p>')
            }else{
                $(this).parent().removeClass('validation');
                $(this).parent().addClass('validated');
            }

        })

        select.on('change', function(){
            $(this).parent().addClass('validated');
        })


    }
}

export {validator}